export const PASSWORD_REG_EXP = /^(?![^a-zA-Z]+$)(?!\D+$)/ //必须有字母、数字
